"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTeams = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getTeams = function (generationNumber) {
    return core_1.default.get({
        url: '/teams',
        params: { generationNumber: generationNumber },
    });
};
exports.getTeams = getTeams;
